import { NSCard } from 'bricks';
import React from 'react';
import { CardBody } from 'reactstrap';
import NSUserAvatar from 'bricks/NSUserAvatar/NSUserAvatar';
import { URLS } from 'services/urls';
import { IProjectCRMAssociation } from '../types';
import { projectIconFallback } from '../constants';

const ProjectCard = ({
    coverImageIcon, subprojectName, developmentProjectName, id,
}: IProjectCRMAssociation) => {
    const handleCardClick = () => {
        window.location.href = `${URLS.PROJECTS_APP.PROJECT_DASHBOARD_V2(id)}?tab=activity`;
    };

    return (
        <NSCard
            className="NSCard--level-3 p-2 my-2 cursor--pointer"
            onClick={handleCardClick}
        >
            <CardBody className="d-flex justify-content-start align-items-center p-0">
                <NSUserAvatar
                    userPicture={URLS.IMAGE_CLOUDFRONT_URL(coverImageIcon || projectIconFallback)}
                    className="mr-2"
                />
                <div>
                    <span className="text-dark d-block">{ subprojectName }</span>
                    <div className="d-flex align-items-center">
                        <small className="text-muted">{ developmentProjectName }</small>
                    </div>
                </div>
            </CardBody>
        </NSCard>
    );
};

export default ProjectCard;
